import React from 'react';
import { Box, Rating, Typography, FormControlLabel, Checkbox } from '@mui/material';

interface StarsFieldWithCheckProps {
  id: string;
  label: string;
  labelLeft: string;
  labelRight: string;
  value: number | null;
  nullable?: boolean;
  onChange: (id: string, value: number | null) => void;
  step?: number;
  readOnly?: boolean;
}

const StarField: React.FC<StarsFieldWithCheckProps> = ({
  id,
  label,
  labelLeft,
  labelRight,
  value,
  onChange,
  nullable = false,
  readOnly = false,
}) => {
  const isNotApplicable = value === null;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(id, null);
    } else {
      onChange(id, 0);
    }
  };

  return (
    <div>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography id={`${id}-label`} sx={{ flex: 1, textAlign: 'left' }}>
          {label}
        </Typography>
        {!readOnly && nullable && (
          <FormControlLabel
            control={
              <Checkbox checked={isNotApplicable} onChange={handleCheckboxChange} size="small" />
            }
            label={
              <Typography variant="body2" color="text.secondary">
                No aplica
              </Typography>
            }
            sx={{ ml: 2 }}
          />
        )}
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          opacity: isNotApplicable && !readOnly ? 0.4 : 1,
          pointerEvents: isNotApplicable && !readOnly ? 'none' : 'auto',
        }}
      >
        <Typography
          id={`${id}-label-left`}
          variant="body2"
          sx={{ width: '35%', textAlign: 'right' }}
        >
          {labelLeft}
        </Typography>
        <Rating
          id={`${id}-stars`}
          name={`${id}-stars`}
          value={value ?? 0}
          onChange={(_, newValue) => {
            onChange && onChange(id, newValue ?? 0);
          }}
          readOnly={readOnly}
        />
        <Typography
          id={`${id}-label-right`}
          variant="body2"
          sx={{ width: '35%', textAlign: 'left' }}
        >
          {labelRight}
        </Typography>
      </Box>
    </div>
  );
};

export default StarField;
